export enum KnmInvalidFieldEnum {
  KNO_ORGANIZATION_ERKNM = 'knmErknm.knoOrganization',
  KIND_CONTROL = 'knmErknm.kindControl',
  KIND_KNM = 'knmErknm.kindKnm',
  TYPE_ERKNM = 'type',
  REASONS_ERKNM_ERVK_UUID = 'knmErknm.reasons[{id}].reason',
  REASONS_ERKNM_ORDER = 'knmErknm.reasons[{id}].order',
  REASONS_ERKNM_RISK_INDICATORS = 'knmErknm.reasons[{id}].riskIndicators',
  REASONS_ERKNM_RISK_INDICATOR = 'knmErknm.reasons[{id}].riskIndicators[{id}].riskIndicator',
  PROSECUTOR_ORGANIZATION_ERKNM = 'prosecutorOrganization',
  OBJECTS_ERKNM_ERVK_ID = 'knmErknm.objects[{id}]',
  OBJECTS_ERKNM_OBJECT_TYPE = 'knmErknm.objects[{id}].objectType',
  OBJECTS_ERKNM_OBJECT_KIND = 'knmErknm.objects[{id}].objectKind',
  OBJECTS_ERKNM_OBJECT_SUB_KIND = 'knmErknm.objects[{id}].objectSubKind',
  OBJECTS_ERKNM_RISK_CATEGORY = 'knmErknm.objects[{id}].riskCategory',
  OBJECTS_ERKNM_DANGER_CLASS = 'knmErknm.objects[{id}].dangerClass',
  ORGANIZATIONS_SUBJECT_TYPE = 'knmErknm.organizations[{id}].subjectType',
  ORGANIZATIONS_ERVK_ID = 'knmErknm.organizations[{id}].ervkId',
  INSPECTORS_ERKNM_POSITION = 'knmErknm.inspectors[{id}].position',
  EXPERTS_TYPE = 'knmErknm.experts[{id}].type.id',
  COLLABORATING_ORGANIZATIONS_ITEM_ORGANIZATION = 'knmErknm.collaboratingOrganizations[{id}].organization',
  EVENTS_ERKNM_TYPE = 'knmErknm.events[{id}].event',
  REQUIREMENTS_NPA_ERKNM_NPA_ID = 'knmErknm.requirementsNew[{id}]',
  REQUIREMENTS_NPA_ERKNM_STRUCTURAL_UNIT_ID = 'knmErknm.requirementsNew[{id}].structuralUnit',
  DOC_TARGET_ERVK_CONTROL_KIND_DOC_TARGET = 'knmErknm.docTarget[{id}].ervkControlKindDocTarget',
  CHECKLISTS_ERKNM_CHECKLIST = 'knmErknm.checklists[{id}].checkList',
  CHECKLISTS_ERKNM_ERVK_CHECKLIST = 'knmErknm.checklists[{id}].ervkCheckList',
}
